export default "__VITE_ASSET__B5mkG5E8__"